import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { loadSessionRequest } from '../api';
import { loadNewState } from '../actions';

class AppLandingPage extends React.Component {
  static propTypes = {
    sessionId: PropTypes.string.isRequired,
    loadNewState: PropTypes.func.isRequired,
  }

  componentDidMount = () => {
    const success = (object) => {
      this.props.loadNewState(object);
    };
    const failure = (message) => {
      alert(message);
    };
    const { sessionId } = this.props;
    loadSessionRequest(sessionId, success, failure);
  }

  render() {
    return (
      <div className="loading-screen">
        <span>
          <i className="fas fa-spinner fa-spin" />
        </span>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadNewState: data => dispatch(loadNewState(data)),
});

export default connect(null, mapDispatchToProps)(AppLandingPage);
